import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        comingSoon: false
    },
    mutations: {
        setComingSoon(state, value) {
            state.comingSoon = value
        }
    },
    modules: {}
})

export default store
